import {
    POST_INICIAR_SESION, POST_REFRESCAR_TOKEN, POST_ENVIAR_CODIGO
} from '../types';

const user = JSON.parse(localStorage.getItem("user"));

export default function loginReducer(state = {}, action) {
    switch (action.type) {
        case POST_INICIAR_SESION:
            return { ...state, ...action.payload }
        case POST_REFRESCAR_TOKEN:
            return { ...state, user: { ...user, token: action.payload } }
        case POST_ENVIAR_CODIGO:
            return { ...state, ...action.payload }
        default:
            return state
    }
}